import { Spinner } from '@/shared/ui/primitives';
import type { FC } from 'react';

import styles from './LoadingFallback.module.css';

export const LoadingFallback: FC = () => (
  <div className={styles.center} data-testid="loading-state" aria-live="polite">
    <Spinner size="md" />
  </div>
);
